import { __rest } from "tslib";
import * as React from 'react';
import { st, classes } from './ReviewSummary.st.css';
import { REVIEW_SUMMARY_DATA_HOOKS } from './dataHooks';
import { ProgressBar } from '../ProgressBar';
/** ReviewSummary is intended to be used as a visual breakdown of different given values. For example: Rating Breakdown. */
export class ReviewSummary extends React.Component {
    render() {
        const { className, items } = this.props;
        const isClickable = items.findIndex((item) => item.onClick) !== -1;
        return (React.createElement("div", { className: st(classes.root, className), "data-hook": this.props['data-hook'], "aria-describedby": this.props['aria-describedby'], "aria-label": this.props['aria-label'], role: "group" },
            React.createElement("ol", { className: st(classes.itemList, {
                    withSuffix: !!items.find((i) => i.showProgressIndication),
                    withPrefix: !!items.find((i) => i.prefixIndication),
                }) }, items.map((item, index) => {
                const { onClick = () => { } } = item, itemProps = __rest(item, ["onClick"]);
                return (React.createElement("li", { key: index, className: classes.itemWrapper },
                    React.createElement(ProgressBar, Object.assign({ className: st(classes.progressBar, {
                            clickable: isClickable,
                        }), "data-hook": REVIEW_SUMMARY_DATA_HOOKS.Item, role: isClickable ? '' : 'group', "aria-hide-affixes": true, size: "large" }, (isClickable ? { onClick } : {}), itemProps))));
            }))));
    }
}
ReviewSummary.displayName = 'ReviewSummary';
//# sourceMappingURL=ReviewSummary.js.map